import { render, staticRenderFns } from "./basmsg.vue?vue&type=template&id=b98ad678&scoped=true&"
import script from "./basmsg.vue?vue&type=script&lang=js&"
export * from "./basmsg.vue?vue&type=script&lang=js&"
import style0 from "./basmsg.vue?vue&type=style&index=0&id=b98ad678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98ad678",
  null
  
)

export default component.exports